/**
 * 半角￥を全角￥に置き換える
 */
export default class StringUtil {
  /**
   * 半角￥をandroidやiOSの半角￥に置き換える
   * UTF8の文字コードは以下になっているので半角￥の文字コードをA5に変換する
   *
   * - Windows
   *   - 円マーク: 5C
   *   - バックスラッシュ: 5C
   * - Mac・iOS・Android
   *   - 円マーク: A5
   *   - バックスラッシュ: 5C
   *
   * @param args 変換対象文字列
   */
  public convertYen(args: string): string {
    const convertedArgs: string = args.replace(/\\/g, "\xA5");

    return convertedArgs;
  }

  /**
   * ### 配列無いの値の重複を削除する
   *
   * - プリミティブ型（数値、文字列、真偽値、null, undefined, Symbol, BigInt）のみ対応
   * - Objectを渡すと値が同じでも別物と扱うので注意
   *   - Setはオブジェクトの参照（メモリ上のアドレス）が同じであるかをチェックするでの、参照が異なったら別物扱いになる
   */
  public removeDuplicatesUsingSet<T>(arr: T[]): T[] {
    return Array.from(new Set(arr));
  }
}
